import axiosInstance, { axiosInstanceWithAuth } from './axios';

const postApi = (url: string, data: any) =>
    axiosInstance(url, {
        method: 'POST',
        data,
    });

export const putApi = (url: string, data: any) =>
    axiosInstance(url, {
        method: 'PUT',
        data,
    });

export const postApiWithAuth = (
    url: string,
    data: any,
    queryParams?: Record<string, string | number | Array<string | number>>,
) =>
    axiosInstanceWithAuth(url, {
        method: 'POST',
        data,
        params: queryParams,
    });

export default postApi;

export const putApiWithAuth = (
    url: string,
    data: any,
    queryParams?: Record<string, string | number | Array<string | number>>,
) =>
    axiosInstanceWithAuth(url, {
        method: 'PUT',
        data,
        params: queryParams,
    });

export const getApi = (url: string, queryParams?: Record<string, string | number | Array<string | number>>) => {
    let query = '';
    const params = queryParams ?? {};
    Object.keys(params).forEach((qp) => {
        if (Array.isArray(params[qp])) {
            (params[qp] as unknown as Array<string | number>).forEach((qpv) => {
                query += `${qp}=${qpv}&`;
            });
        } else {
            query += `${qp}=${params[qp]}&`;
        }
    });
    query = query.substring(0, query.length - 1);
    return axiosInstanceWithAuth(`${url}${query ? `?${query}` : ``}`, {
        method: 'GET',
    });
};

export const parseError = (e: any) => {
    let err = '';
    if (e?.response?.data) {
        const error = e.response.data;
        if (error) {
            if (error.errors instanceof Array) {
                err = error.errors[0].message;
            } else if (error.errors instanceof Object) {
                err = error.errors.message;
            } else if (typeof error.errors === 'string') {
                err = error.errors;
            }
        } else {
            err = e.message;
        }
    }
    return err;
};
